export default "__VITE_ASSET__BA4Ftlu2__"